import React from 'react';
import { useTranslation } from 'react-i18next';

import HomeSocialProofSection from '../components/HomePage/sections/HomeSocialProofSection';
import MarketingPageShell from '../components/marketing/MarketingPageShell';

interface SuccessStoriesPageProps {
  onNavigate?: (view: string) => void;
}

const SuccessStoriesPage: React.FC<SuccessStoriesPageProps> = ({ onNavigate }) => {
  const { t } = useTranslation();

  return (
    <MarketingPageShell
      onNavigate={onNavigate}
      activeView="success-stories"
      title={t('pages.successStories.seoTitle', 'Success Stories | GoGrabJob')}
      description={t(
        'pages.successStories.seoDescription',
        'Real job seekers improving ATS scores, landing interviews, and getting recruiter calls with GoGrabJob.',
      )}
      canonical="https://www.gograbjob.com/success-stories"
    >
      <HomeSocialProofSection
        onNavigate={onNavigate}
        layout="marquee"
        showCta
      />
    </MarketingPageShell>
  );
};

export default SuccessStoriesPage;
